import React from 'react';
import markdown from 'showdown';
import { removeInlineStyleAttributes } from 'utils/removeInlineStyleAttributes';

import { MarkdownContentWrapper } from './MarkdownContent.styles';
import { MarkdownContentProps } from './MarkdownContent.types';

const markDownConverter = new markdown.Converter();

export const MarkdownContent = ({ children }: MarkdownContentProps) => {
  const html = removeInlineStyleAttributes(markDownConverter.makeHtml(children));

  return <MarkdownContentWrapper dangerouslySetInnerHTML={{ __html: html }} />;
};
